import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { firstLettersToUpperCase } from "../../additional/functions";
import { BaseQueryErrorHandler } from "./@utils/BaseQueryErrorHandler";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api/v2/ai-host/model",
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");

    return headers;
  },
});

const baseQuery = BaseQueryErrorHandler(rawBaseQuery);

export const modelsApi = createApi({
  reducerPath: "modelsApi",
  baseQuery,
  endpoints: (builder) => ({
    getInfo: builder.query({
      query: () => "/info",
      transformResponse: (response) => {
        const formattedData = Object.entries(response).flatMap(
          ([group, labels]) =>
            Object.entries(labels).map(([label, items]) => ({
              group,
              groupLabel: firstLettersToUpperCase(group, "_", true),
              label: firstLettersToUpperCase(label, "_", true),
              name: label,
              versions: items.map(({ version, threshold }) => ({
                version,
                threshold,
              })),
            }))
        );

        return formattedData;
      },
    }),
    postThreshold: builder.mutation({
      query: ({ Threshold, Category, ModelName, ModelVer }) => ({
        url: "/threshold",
        method: "POST",
        body: { Threshold, Category, ModelName, ModelVer },
      }),
    }),
    postInterpret: builder.mutation({
      query: ({ Title, Category, ModelName, ModelVer }) => ({
        url: "/interpret",
        method: "POST",
        body: { title: Title, Category, ModelName, ModelVer },
      }),
    }),
  }),
});

export const {
  useGetInfoQuery,
  usePostThresholdMutation,
  usePostInterpretMutation,
} = modelsApi;
